import React, {useEffect, useState} from "react";
import {Active} from "./components/Active";
import {Audio} from "./components/Audio";
import {CommandLine} from "./components/CommandLine";
import {Recipes} from "./components/Recipes";
import {Timers} from "./components/Timer";
import styles from "./App.module.css";

function App() {
  return (
    <div className={styles.App}>
      <div className={styles.top}>
        <Timers />
        <Recipes />
        <Audio />
        <CommandLine />
      </div>
      <div className={styles.bottom}>
        <Active />
      </div>
    </div>
  );
}

export default App;
